import { baseApi } from 'sama-shared';
import type { AdminIndustry } from '../types/admin';
import type { IndustryTypeCode } from '../../constants/industryType';

export interface GetIndustriesParams {
  page?: number;
  limit?: number;
  type?: IndustryTypeCode;
}

export interface IndustryBody {
  name: string;
  type: IndustryTypeCode;
}

export const industryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getIndustries: builder.query<AdminIndustry[], GetIndustriesParams>({
      query: (params) => ({
        url: '/admin/industry',
        method: 'GET',
        params,
      }),
      providesTags: [{ type: 'Industry', id: 'LIST' }],
    }),
    createIndustry: builder.mutation<AdminIndustry, IndustryBody>({
      query: (body) => ({
        url: '/admin/industry',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'Industry', id: 'LIST' }],
    }),
    // El nombre/tipo de la industria viene embebido en cada partner → refrescar partners también
    updateIndustry: builder.mutation<AdminIndustry, Partial<IndustryBody> & { id: string }>({
      query: ({ id, ...body }) => ({
        url: `/admin/industry/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [
        { type: 'Industry', id: 'LIST' },
        { type: 'Partner', id: 'LIST' },
      ],
    }),
    deleteIndustry: builder.mutation<void, string>({
      query: (id) => ({
        url: `/admin/industry/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [
        { type: 'Industry', id: 'LIST' },
        { type: 'Partner', id: 'LIST' },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetIndustriesQuery,
  useCreateIndustryMutation,
  useUpdateIndustryMutation,
  useDeleteIndustryMutation,
} = industryApi;
